import { Component } from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from 'react-i18next'
import Slider from "react-slick"
import { isMobile } from "react-device-detect"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

class AvisVideoExpert extends Component {
  render() {
    const { t } = this.props

    const videos = [
      {
        name: "Alexandra Portail",
        job: "Naturopathe",
        url: "https://www.youtube.com/embed/RJ7ZKxp6gEs"
      },
      {
        name: "Lucie Houbart",
        job: "Diététicienne nutritionniste",
        url: "https://www.youtube.com/embed/AYLN23hiHeo"
      },
      {
        name: "Nathalie Saunier",
        job: "Naturopathe",
        url: "https://www.youtube.com/embed/iLfHbpRLlqc"
      }
    ]

    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true
    }

    return (
      <div className="py-5">
        <Container>
          <h2 className="mb-5 text-center dark-blue">{t("avisclients|L’avis de nos experts sur l’analyse du microbiote")}</h2>
          <p className="text-center">{t("avisclients|Nous travaillons en étroite collaboration avec des spécialistes de la nutritionreconnus. Ils vous expliquent pourquoi l’analyse du microbiote intestinal est aujourd’hui un outil incontournable pour mieux comprendre son corps, adapter son alimentation etagir durablement sur son bien-être.")}</p>
          <p className="pb-3 text-center">{t("avisclients|Leur regard professionnel vous aide à mieux comprendre les bénéfices concrets du test Nahibu et la manière dont il peut transformer votre approche de la santé.")}</p>

          {isMobile ? (
            <Slider {...sliderSettings}>
              {videos.map((video, index) => (
                <div key={index} className="text-center px-2">
                  <div className="video-wrapper mb-3">
                    <iframe
                      width="100%"
                      height="215"
                      src={video.url}
                      title={`Avis de ${video.name}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <p>{video.name}</p>
                  <p>{video.job}</p>
                </div>
              ))}
            </Slider>
          ) : (
            <Row className="text-center">
              {videos.map((video, index) => (
                <Col md={4} key={index} className="mb-4">
                  <div className="video-wrapper mb-3">
                    <iframe
                      width="100%"
                      height="215"
                      src={video.url}
                      title={`Avis de ${video.name}, ${video.job}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                  <p>{video.name}</p>
                  <p>{t(`avisclients|${video.job}`)}</p>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>
    )
  }
}

export default withTranslation("avisclients")(AvisVideoExpert)
